var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHovergivings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.26172 17.507L5.45098 20.998C6.06715 21.5114 6.84382 21.7927 7.64588 21.7927H18.6904C19.4793 21.7927 20.1189 21.1531 20.1189 20.364C20.1189 18.7862 18.8397 17.507 17.2617 17.507H9.58337",
    stroke: "#EFBC51",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40457 15.7926L7.69028 17.0783C8.40038 17.7885 9.55164 17.7885 10.2617 17.0783C10.9718 16.3683 10.9718 15.217 10.2617 14.5069L8.26592 12.5111C7.62295 11.8681 6.75087 11.5069 5.84156 11.5069H1.26172",
    stroke: "#EFBC51",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3086 8.09418C11.707 7.9895 11.707 7.1259 12.3086 7.02124C14.4881 6.64206 16.2216 4.98201 16.6946 2.82098L16.7309 2.65533C16.861 2.06075 17.7076 2.05706 17.8431 2.65046L17.8869 2.84351C18.3776 4.99435 20.1116 6.64038 22.2849 7.0185C22.8896 7.12369 22.8896 7.99171 22.2849 8.0969C20.1116 8.47502 18.3776 10.121 17.8869 12.2719L17.8431 12.4649C17.7076 13.0583 16.861 13.0547 16.7309 12.4601L16.6946 12.2944C16.2216 10.1334 14.4881 8.47334 12.3086 8.09418Z",
    stroke: "#EFBC51",
    strokeWidth: 1.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHovergivings);
export default __webpack_public_path__ + "static/media/hovergivings.4bc348e7ad9bc1c45f3246a9117e610d.svg";
export { ForwardRef as ReactComponent };